module.exports = __webpack_public_path__ + "assets/f50242e4685c740ff1ea7de8d0b5845a.mp3";